module.exports = __webpack_public_path__ + "static/media/bg5.16f617be.mp4";